import React from 'react';

/**
 * Lightweight inline-SVG icon component.
 * Uses a curated path library matching the design spec.
 */
const PATHS = {
  // navigation / chrome
  bell:         "M6 8a6 6 0 0 1 12 0c0 4 1.5 5 2 6H4c.5-1 2-2 2-6Zm3 10a3 3 0 0 0 6 0",
  search:       "m20 20-3.5-3.5M11 18a7 7 0 1 1 0-14 7 7 0 0 1 0 14Z",
  plus:         "M12 5v14M5 12h14",
  minus:        "M5 12h14",
  x:            "M6 6l12 12M18 6L6 18",
  check:        "M5 12l5 5L20 7",
  chevronDown:  "m6 9 6 6 6-6",
  chevronLeft:  "m15 6-6 6 6 6",
  chevronRight: "m9 6 6 6-6 6",
  chevronUp:    "m6 15 6-6 6 6",
  arrowRight:   "M5 12h14m-5-5 5 5-5 5",
  arrowLeft:    "M19 12H5m5 5-5-5 5-5",
  arrowUpDown:  "M8 3v18m0 0-3-3m3 3 3-3M16 21V3m0 0-3 3m3-3 3 3",
  // documents / files
  upload:       "M12 3v12m0-12L8 7m4-4 4 4M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2",
  download:     "M12 3v12m0 0-4-4m4 4 4-4M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2",
  file:         "M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5Zm0 0v5h5",
  folder:       "M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7Z",
  pen:          "M12 20h9M16.5 3.5a2.1 2.1 0 1 1 3 3L7 19l-4 1 1-4 12.5-12.5Z",
  signature:    "M3 17c3-1 6-4 8-8s3-7 5-6-1 4 0 7 5 2 5 7",
  paperclip:    "M21 11 11 21a5 5 0 0 1-7-7l9-9a4 4 0 0 1 5 5l-9 9a2 2 0 0 1-3-3l8-8",
  stack:        "M4 7l8-4 8 4-8 4-8-4Zm0 5 8 4 8-4M4 17l8 4 8-4",
  grip:         "M9 4a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm6 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM9 11a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm6 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM9 18a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm6 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z",
  // people
  user:         "M5 20a7 7 0 0 1 14 0M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
  users:        "M2 20a6 6 0 0 1 12 0M14 20a6 6 0 0 1 8-2M8 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm10 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
  eye:          "M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Zm10 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
  // actions
  trash:        "M4 7h16M6 7v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2m-5 4v6m4-6v6",
  refresh:      "M3 12a9 9 0 0 1 15-6.7L21 8m0 0V3m0 5h-5M21 12a9 9 0 0 1-15 6.7L3 16m0 0v5m0-5h5",
  ban:          "M4.9 4.9 19 19M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z",
  logout:       "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4m6 14 5-5-5-5m5 5H9",
  key:          "M14 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm0 0 7 7-2 2-2-2-2 2-2-2",
  filter:       "M3 5h18l-7 9v5l-4 2v-7L3 5Z",
  settings:     "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm7.4-3a7.7 7.7 0 0 0-.1-1.5l2-1.5-2-3.5-2.4.8a7.6 7.6 0 0 0-2.6-1.5L14 2h-4l-.3 2.3a7.6 7.6 0 0 0-2.6 1.5l-2.4-.8-2 3.5 2 1.5a7.7 7.7 0 0 0 0 3L2.7 14.5l2 3.5 2.4-.8a7.6 7.6 0 0 0 2.6 1.5L10 21h4l.3-2.3a7.6 7.6 0 0 0 2.6-1.5l2.4.8 2-3.5-2-1.5a7.7 7.7 0 0 0 .1-1.5Z",
  sparkle:      "M12 3v6m0 6v6m-9-9h6m6 0h6M6 6l4 4m4 4 4 4M6 18l4-4m4-4 4-4",
  shield:       "M12 3 4 6v6c0 5 3.5 8 8 9 4.5-1 8-4 8-9V6l-8-3Zm-3 9 2 2 4-4",
  type:         "M4 6V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v1M12 4v16m-4 0h8",
  // status
  dot:          "M12 12m-4 0a4 4 0 1 0 8 0 4 4 0 1 0-8 0",
  checkCircle:  "M9 12l2 2 4-4m-2-7a9 9 0 1 1 0 18 9 9 0 0 1 0-18Z",
  clockBadge:   "M12 7v5l3 2m-3 7a9 9 0 1 1 0-18 9 9 0 0 1 0 18Z",
  clock:        "M12 8v4l3 2m-3 8a10 10 0 1 0 0-20 10 10 0 0 0 0 20Z",
  alert:        "M12 9v4m0 4h.01M10.3 4.1 2.5 17.4a2 2 0 0 0 1.7 3h15.6a2 2 0 0 0 1.7-3L13.7 4.1a2 2 0 0 0-3.4 0Z",
  infoI:        "M12 11v5m0-8h.01M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0Z",
  // misc
  calendar:     "M4 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7Zm4-4v4m8-4v4M4 11h16",
  mail:         "M4 6h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1Zm0 1 8 6 8-6",
  barChart:     "M4 20v-4m6 4V10m6 10V6M4 20h16",
  more:         "M5 12h.01M12 12h.01M19 12h.01",
  zoomIn:       "M11 18a7 7 0 1 1 0-14 7 7 0 0 1 0 14Zm-3-7h6m-3-3v6m9 10-3.5-3.5",
  zoomOut:      "M11 18a7 7 0 1 1 0-14 7 7 0 0 1 0 14Zm-3-7h6m9 10-3.5-3.5",
  menu:         "M4 6h16M4 12h16M4 18h16",
  code:         "M16 18l6-6-6-6M8 6l-6 6 6 6",
};

const Icon = ({ name, size = 16, className = '', strokeWidth = 1.75 }) => {
  const d = PATHS[name] || PATHS.dot;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path d={d} />
    </svg>
  );
};

export default Icon;
